import posthog from 'posthog-js';

// Feature flags (PostHog). Keep flag keys here so gates read from one place.
export const PROJECTS_V2_FLAG = 'projects-v2';

// The projects "v2" experience: deliverables + tasks + documents, the redesigned
// project overview, the new project-form fields, and the richer projects rows.
// Everything in that set is gated behind this flag.
export const isProjectsV2Enabled = (): boolean => !!posthog.isFeatureEnabled(PROJECTS_V2_FLAG);

export const REFRIGERANT_TRACKING_FLAG = 'refrigerant_tracking_enabled';

// EPA 608 refrigerant tracking: the Refrigerant Tracking tabs (asset overview, asset detail, work
// order detail) and everything behind them, the refrigerant fields on the asset and asset-type
// forms, the technician's EPA certification on the contact/field-tech/role forms, and the work
// order "Has Refrigerant Events" filter. Every one of those gates reads this flag.
//
// Gating the WRITE paths matters as much as the UI: with the fields unrendered, the payload
// builders would send `isRefrigerantTracked: false` / an explicit cleared certification and a
// flag-off user saving an unrelated attribute would silently wipe a flag-on user's data. Wherever a
// form is gated, the corresponding submit-side branch is gated on the same call.
export const isRefrigerantTrackingEnabled = (): boolean =>
	!!posthog.isFeatureEnabled(REFRIGERANT_TRACKING_FLAG);
